import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import * as Mui from "@mui/material";
import { Grid, TextField } from "@mui/material";
import { customTheme } from "../../../../../config/theme/MuiTheme";
import useOperationTranslation from "../../../hooks/useOperationTranslation";

interface Props {
    open: boolean;
    onClose: () => void;
    taskName : string;
    results: any;
};
const ShowLeasysResults = (props: Props) => {
    const t = useOperationTranslation();

    return(
        <Mui.Dialog
            open={props.open}
            fullWidth
            maxWidth="sm"
            onClose={props.onClose}
        >
            <Mui.DialogTitle>
                <Mui.Grid container spacing={1}>
                    <Mui.Grid item color={customTheme.palette.accent.main}>
                        <InfoIcon color="inherit" />
                    </Mui.Grid>
                    <Mui.Grid item>
                        <Mui.Typography variant="h5">
                            {t("damageForm.details.dialogs.leasysResults.title")}
                        </Mui.Typography>
                    </Mui.Grid>
                    <Mui.Grid item marginLeft={"auto"}>
                        <Mui.IconButton onClick={props.onClose} style={{padding: "0px"}} >
                            <CloseIcon />
                        </Mui.IconButton>
                    </Mui.Grid>
                </Mui.Grid>
            </Mui.DialogTitle>
            <Mui.DialogContent>
                <Grid container spacing={3}>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled
                            id="totalClaimsRead"
                            name="totalClaimsRead"
                            label={t("damageForm.details.dialogs.leasysResults.totalClaimsRead")}
                            value={props.results?.totalClaimsRead}
                            //size="small"
                            />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled
                            id="totalClaimsNotFound"
                            name="totalClaimsNotFound"
                            label={t("damageForm.details.dialogs.leasysResults.totalClaimsNotFound")}
                            value={props.results?.totalClaimsNotFound}
                            //size="small"
                            />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled
                            id="totalClaimsElaborated"
                            name="totalClaimsElaborated"
                            label={t("damageForm.details.dialogs.leasysResults.totalClaimsElaborated")}
                            value={props.results?.totalClaimsElaborated}
                            //size="small"
                            />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            fullWidth
                            disabled
                            id="totalClaimsNotUpdatable"
                            name="totalClaimsNotUpdatable"
                            label={t("damageForm.details.dialogs.leasysResults.totalClaimsNotUpdatable")}
                            value={props.results?.totalClaimsNotUpdatable}
                            //size="small"
                            />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            disabled
                            id="claimsNotFoundList"
                            name="claimsNotFoundList"
                            label={t("damageForm.details.dialogs.leasysResults.claimsNotFoundList")}
                            value={props.results?.claimsNotFoundList?.length > 0 ? props.results.claimsNotFoundList : ' '}
                            multiline
                            maxRows={10}
                            />
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            disabled
                            id="claimsNotUpdatableList"
                            name="claimsNotUpdatableList"
                            label={t("damageForm.details.dialogs.leasysResults.claimsNotUpdatableList")}
                            value={props.results?.claimsNotUpdatableList?.length > 0 ? props.results.claimsNotUpdatableList : ' '}
                            multiline
                            maxRows={10}
                            />
                    </Grid>
                    
                    
                </Grid>

                
            </Mui.DialogContent>
            
        </Mui.Dialog>
    )
}
export default ShowLeasysResults;